import * as React from 'react';
import { createContext, useContext } from 'react';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

type NavAiSparkleExperimentContextType = {
  showNavAiSparkle: boolean;
};

const NavAiSparkleExperimentContext = createContext<NavAiSparkleExperimentContextType>({
  showNavAiSparkle: false,
});

export const useNavAiSparkle = () => {
  return useContext(NavAiSparkleExperimentContext);
};

const NavAiSparkleExperimentProvider = ({ children }: React.PropsWithChildren) => {
  const showNavAiSparkle = GrowthDiscoveryEpicClient.get('showNavAiSparkle');
  return (
    <NavAiSparkleExperimentContext.Provider value={{ showNavAiSparkle }}>
      {children}
    </NavAiSparkleExperimentContext.Provider>
  );
};

export default NavAiSparkleExperimentProvider;
